import axios,{buildApi} from '@/libs/api.request';
let name = '/report/Timeout/'

export const apis = buildApi({
  get:[ name+'/abnormal',name+'/service',name+'/delivery'],
})